export default __webpack_public_path__ + "static/media/Support.b3da96df.png";